import * as React from 'react'

import { SubmitSwiper as SubmitSwiperPresenter, IProps } from './presenter'

export const SubmitSwiper = (props: IProps): JSX.Element => {
  return <SubmitSwiperPresenter {...props} />
}

export default SubmitSwiper
